module.exports = __webpack_public_path__ + "static/media/barbara2.28671a98.mp3";